module.exports = __webpack_public_path__ + "img/P579205804.17828789.jpg";